import type {SchedulerTemplateForm} from 'src/types/scheduler/template-form';
import type {SchedulerTemplateFormActions} from 'src/action-creators/scheduler/template-form';

import {
  SET_TEMPLATE_FORM,
  UPDATE_TEMPLATE_FORM,
  UPDATE_TEMPLATE_FORM_FIELDS,
} from 'src/action-creators/scheduler/template-form';


export const initialState: SchedulerTemplateForm = {
  id: '',
  name: '',
  brandId: '',
  usages: [],
  linkUrl: '',
  agentId: '',
  timezone: '',
  location: '',
  urlSuffix: '',
  language: 'en',
  duration: {amount: 30, unit: 'minutes'},
  description: '',
  ccEmailIds: [],
  bufferTime: {amount: 0, unit: 'minutes'},
  linkUrlShort: '',
  maxEventSize: 0,
  capacity: [],
  futureLimit: {amount: 30, unit: 'days'},
  maxEventsPerDay: 0,
  isTeamTemplate: false,
  sendEventBookingSms: false,
  locationMeta: [],
  eventReminders: [],
  cancellationPolicy: '',
  minBookingNotice: {amount: 1, unit: 'days'},
  sendEventBookingEmail: false,
  minCancellationNotice: {amount: 1, unit: 'days'},
  openBookingSlots: [],
  bookingAccounts: [],
  requireBookingConfirmation: false,
  overrideCalendarAvailability: false,
  distributionRule: 'single_account',
  additionalQuestions: [],
  eventConfirmationNotifications: {
    cancelEvent: [],
    scheduleEvent: [],
    rescheduleEvent: [],
    requestRescheduleEvent: [],
  },
  templateType: 'standard',
  assignments: {
    agents: 0,
    securityGroups: 0,
    isAssignedToAll: false,
  },
  rules: [],
  workingAssignments: {
    isAssignedToAll: false,
    inclusions: {
      agentIds: [],
      securityGroupIds: [],
    },
    exclusions: {
      agentIds: [],
      securityGroupIds: [],
    },
  },
};

export default (
  state: SchedulerTemplateForm = initialState,
  action: SchedulerTemplateFormActions,
): SchedulerTemplateForm => {
  switch (action.type) {
    case SET_TEMPLATE_FORM:
      return {...state, ...action.payload};
    case UPDATE_TEMPLATE_FORM:
      const {field, value} = action.payload;
      return {
        ...state,
        [field]: value,
      };
    case UPDATE_TEMPLATE_FORM_FIELDS:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
};
